import {
  faCodeBranch,
  faClockRotateLeft
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { useMemo, useState } from 'react';
import { Modal, Nav } from 'react-bootstrap';
import whatsNewFeed from 'data/whatsNew';

interface WhatsNewNavItemProps {
  slim?: boolean;
}

const formatTimestamp = (timestamp: string) =>
  new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short'
  }).format(new Date(timestamp));

const WhatsNewNavItem = ({ slim = false }: WhatsNewNavItemProps) => {
  const [show, setShow] = useState<boolean>(false);

  const generatedAtLabel = useMemo(
    () => formatTimestamp(whatsNewFeed.generatedAt),
    []
  );

  return (
    <>
      <Nav.Item>
        <Nav.Link
          onClick={() => setShow(true)}
          className={classNames('d-flex align-items-center', {
            'py-0': slim,
            'h-100': !slim
          })}
          title="What's new"
          aria-label="What's new"
        >
          <FeatherIcon icon="star" size={slim ? 12 : 18} />
        </Nav.Link>
      </Nav.Item>

      <Modal show={show} onHide={() => setShow(false)} centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>What&apos;s New</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex flex-wrap gap-3 text-muted fs-10 mb-3">
            <span className="d-inline-flex align-items-center gap-2">
              <FontAwesomeIcon icon={faCodeBranch} />
              {whatsNewFeed.branch}
            </span>
            <span className="d-inline-flex align-items-center gap-2">
              <FontAwesomeIcon icon={faClockRotateLeft} />
              Updated {generatedAtLabel}
            </span>
          </div>

          <p className="text-muted mb-3">
            Recent release notes pulled from this branch&apos;s git history.
          </p>

          {whatsNewFeed.items.length === 0 ? (
            <p className="mb-0 text-muted">
              No release notes are available yet.
            </p>
          ) : (
            whatsNewFeed.items.map((entry, index) => (
              <div
                key={entry.hash}
                className={classNames('border rounded-2 p-3', {
                  'mb-3': index < whatsNewFeed.items.length - 1
                })}
              >
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <span
                      className={classNames(
                        'badge badge-phoenix text-uppercase',
                        entry.type === 'feature'
                          ? 'badge-phoenix-primary'
                          : 'badge-phoenix-warning'
                      )}
                    >
                      {entry.type}
                    </span>
                    {entry.scope && (
                      <span className="fs-10 text-muted">{entry.scope}</span>
                    )}
                  </div>
                  <span className="fs-10 text-muted">
                    {formatTimestamp(entry.timestamp)}
                  </span>
                </div>

                <div className="fw-semibold mt-2">{entry.title}</div>
                <div className="fs-10 text-muted mt-1">Commit {entry.hash}</div>
              </div>
            ))
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WhatsNewNavItem;
